/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Password_Rule_NumberInputs */



/**
* | output |
* | --- |
* | "Password contains a number (0-9)" |
*
* @param {Password_Rule_NumberInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const password_rule_number = /** @type {((inputs?: Password_Rule_NumberInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Password_Rule_NumberInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Password contains a number (0-9)")
	return /** @type {LocalizedString} */ ("Le mot de passe contient un numéro (0-9)")
});